export const isNil = (value: any): value is null | undefined => {
  return value === null || value === undefined
}

export const isStrNil = (value: any): value is null | undefined => {
  return value === null || value === undefined || (typeof value === 'string' && value.trim() === '')
}
